export const getGoalContributionsByMediumMetrics = (state: Record<string, any>) =>
  state.iterableGoals.goalAnalytics.goalContributionsByMediumMetrics;
